export default [
  {
    name: "brainModel",
    type: "gltfLoader",
    path: "/models/brain.glb",
  },

  //? TEXTURES
];
